import NavbarEN from "../components/NavbarEN";
import FooterEN from "../components/FooterEN";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { FadeIn } from "../components/AnimationWrapper";
import { useRef } from "react";
import { Helmet } from "react-helmet-async";

export default function CareersEN() {
  const heroHeadingRef = useRef(null);

  return (
    <>
      <NavbarEN heroHeadingRef={heroHeadingRef} />
      <Helmet>
        <html lang="en" />
        <title>Careers – CV Box | Join Our Team</title>
        <meta name="description" content="Join the CV Box team. No open positions at the moment, but we're always looking for talented people." />
        <link rel="canonical" href="https://cv-box.com/en/careers" />
      </Helmet>

      <main>
        <section className="pt-32 lg:pt-44 pb-20 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] min-h-[40vh] flex items-center">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <FadeIn>
              <h1 ref={heroHeadingRef} className="text-4xl lg:text-5xl font-bold text-white mb-4">Careers at CV Box</h1>
              <p className="text-white/60 text-lg max-w-xl mx-auto">
                We're building a product that changes how people search for jobs.
              </p>
            </FadeIn>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-2xl mx-auto px-6 text-center">
            <FadeIn>
              <div className="bg-gray-50 rounded-2xl p-12">
                <span className="text-5xl mb-6 block">🚀</span>
                <h2 className="text-2xl font-medium text-gray-900 mb-4">No open positions at the moment</h2>
                <p className="text-gray-600 text-lg mb-6">
                  We're always looking for talented people. If you think you could strengthen our team — reach out and we'll get in touch when a suitable position opens up.
                </p>
                <a href="mailto:careers@cv-box.com" className="py-3.5 px-8 rounded-full font-bold text-base bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-400 hover:to-emerald-500 hover:shadow-lg hover:shadow-green-500/30 transition-all duration-300 inline-block">
                  Email careers@cv-box.com
                </a>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>

      <ScrollToTopButton />
      <FooterEN />
    </>
  );
}
